var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chatbot-state-viewer" }, [
    _c("div", { staticClass: "viewer-toolbar" }, [
      _c(
        "div",
        { staticClass: "toolbar-controls" },
        [
          _c(
            "a-button",
            {
              attrs: {
                disabled: _vm.currentStepIndex === 0,
                size: "small",
                type: "default",
              },
              on: { click: _vm.rewind },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "18px" },
                },
                [_vm._v("replay")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: {
                disabled: _vm.currentStepIndex === 0,
                size: "small",
                type: "default",
              },
              on: { click: _vm.goToPreviousStep },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "18px" },
                },
                [_vm._v("skip_previous")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.togglePlayPause },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "18px" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.isPlaying ? "pause" : "play_arrow") +
                      "\n                "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: {
                disabled: _vm.currentStepIndex >= _vm.totalSteps - 1,
                size: "small",
                type: "default",
              },
              on: { click: _vm.goToNextStep },
            },
            [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "18px" },
                },
                [_vm._v("skip_next")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar-info" }, [
        _c("span", { staticClass: "step-counter" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$t("message.chatbotStateViewerStep", {
                  current: _vm.currentStepIndex + 1,
                  total: _vm.totalSteps,
                })
              ) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "diagram-map",
        style: { cursor: _vm.mousePressed ? "grabbing" : "grab" },
        on: {
          wheel: _vm.handleWheel,
          mousemove: _vm.handleMove,
          mousedown: function ($event) {
            _vm.mousePressed = true
          },
          mouseup: function ($event) {
            _vm.mousePressed = false
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "map-wrapper", style: { transform: _vm.transform } },
          [
            _vm.blocks && _vm.blocks.blocks && _vm.blocks.blocks.length > 0
              ? _c(
                  "svg",
                  {
                    staticClass: "connectors-layer",
                    attrs: { width: _vm.svgWidth, height: _vm.svgHeight },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-start",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#10b981",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#059669",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-ai",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#06b6d4",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#0891b2",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-flow",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#8b5cf6",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#7c3aed",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-message",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#3b82f6",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#2563eb",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-input",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#f59e0b",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#d97706",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "gradient-default",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#9ca3af",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#6b7280",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.connectors, function (connector) {
                      return _c("path", {
                        key: connector.id,
                        attrs: { d: connector.path },
                      })
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.connectors.filter(function (c) {
                        return _vm.isActiveConnector(c.targetId)
                      }),
                      function (connector) {
                        return _c("path", {
                          key: connector.id + "-active",
                          staticClass: "connector-active",
                          attrs: { d: connector.path },
                        })
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              _vm.blocks && _vm.blocks.blocks ? _vm.blocks.blocks : [],
              function (block) {
                return [
                  _vm.isBlockNavigable(block)
                    ? _c(
                        "a-tooltip",
                        {
                          key: String(block.id) + "-nav",
                          attrs: { placement: "top" },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.clickToOpenBlock"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cb-block",
                              class: {
                                "block-passed":
                                  _vm.passedBlockIds.includes(block.id) &&
                                  block.id !== _vm.currentBlockId,
                                "block-current":
                                  block.id === _vm.currentBlockId,
                                "block-done":
                                  block.id === _vm.currentBlockId &&
                                  _vm.isLastStep,
                                "block-future":
                                  !_vm.passedBlockIds.includes(block.id) &&
                                  block.id !== _vm.currentBlockId,
                              },
                              style: _vm.getBlockStyle(block),
                              attrs: { "data-type": block.type },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onBlockNavigate(block)
                                },
                                mousedown: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "block-caption" }, [
                                _c(
                                  "div",
                                  { staticClass: "block-caption-name" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getBlockDisplayName(block))
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center align-content-center justify-content-start block-icon",
                                  },
                                  [
                                    _c("BlockIconPreview", {
                                      attrs: { "block-type": block.type },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "blockTypeText" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getBlockTypeText(block.type)
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              block.id === _vm.currentBlockId && !_vm.isLastStep
                                ? _c(
                                    "div",
                                    { staticClass: "current-indicator" },
                                    [_c("div", { staticClass: "pulse-dot" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              block.id === _vm.currentBlockId && _vm.isLastStep
                                ? _c("div", { staticClass: "done-indicator" }, [
                                    _c(
                                      "span",
                                      { staticClass: "done-checkmark" },
                                      [_vm._v("✓")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "done-text" }, [
                                      _vm._v("DONE"),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.passedBlockIds.includes(block.id) &&
                              block.id !== _vm.currentBlockId
                                ? _c(
                                    "div",
                                    { staticClass: "passed-indicator" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("check_circle")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        2
                      )
                    : _c(
                        "div",
                        {
                          key: String(block.id) + "-static",
                          staticClass: "cb-block cb-block--no-navigate",
                          class: {
                            "block-passed":
                              _vm.passedBlockIds.includes(block.id) &&
                              block.id !== _vm.currentBlockId,
                            "block-current": block.id === _vm.currentBlockId,
                            "block-done":
                              block.id === _vm.currentBlockId && _vm.isLastStep,
                            "block-future":
                              !_vm.passedBlockIds.includes(block.id) &&
                              block.id !== _vm.currentBlockId,
                          },
                          style: _vm.getBlockStyle(block),
                          attrs: { "data-type": block.type },
                          on: {
                            mousedown: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "block-caption" }, [
                            _c("div", { staticClass: "block-caption-name" }, [
                              _vm._v(_vm._s(_vm.getBlockDisplayName(block))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "block-content" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center align-content-center justify-content-start block-icon",
                              },
                              [
                                _c("BlockIconPreview", {
                                  attrs: { "block-type": block.type },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "blockTypeText" }, [
                                  _vm._v(
                                    _vm._s(_vm.getBlockTypeText(block.type))
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          block.id === _vm.currentBlockId && !_vm.isLastStep
                            ? _c("div", { staticClass: "current-indicator" }, [
                                _c("div", { staticClass: "pulse-dot" }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          block.id === _vm.currentBlockId && _vm.isLastStep
                            ? _c("div", { staticClass: "done-indicator" }, [
                                _c("span", { staticClass: "done-checkmark" }, [
                                  _vm._v("✓"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "done-text" }, [
                                  _vm._v("DONE"),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.passedBlockIds.includes(block.id) &&
                          block.id !== _vm.currentBlockId
                            ? _c("div", { staticClass: "passed-indicator" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("check_circle"),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                ]
              }
            ),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }